import { render, staticRenderFns } from "./OsPreventivaArmazemComponent.vue?vue&type=template&id=e39fd30a&"
import script from "./OsPreventivaArmazemComponent.vue?vue&type=script&lang=js&"
export * from "./OsPreventivaArmazemComponent.vue?vue&type=script&lang=js&"
import style0 from "./OsPreventivaArmazemComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports